export const auditLogSorting = [
  { sortBy: "action", displayText: "ACTION" },
  { sortBy: "resourceType", displayText: "RESOURCE_TYPE" },
  // { sortBy: "actorRole", displayText: "ACTOR_ROLE" },
  { sortBy: "createdAt", displayText: "CREATED_DATE" },
  { sortBy: "result", displayText: "RESULT" },
];

// Format action string from "INTERVIEW_RESET" to "Interview Reset"
export const formatAction = (action) => {
  if (!action) return null;

  // Replace underscores with spaces and convert to title case
  return action
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// Format role string from "HRAdmin" to "HR Admin"
export const formatRole = (role) => {
  if (!role) return null;

  // Handle camelCase roles like "HRAdmin", "AccountantAdmin", "companyAdmin"
  const roleMap = {
    admin: "Admin",
    subadmin: "Sub Admin",
    companyAdmin: "Company Admin",
    HRAdmin: "HR",
    AccountantAdmin: "Accountant",
    employee: "Employee",
    hr: "HR",
    accountant: "Accountant",
    companyadmin: "Company Admin",
    Companyadmin: "Company Admin",
    jobSeeker: "Job Seeker",
  };

  return roleMap[role] || role;
};

// Format result string from "SUCCESS" to "Success"
export const formatResult = (result) => {
  if (!result) return null;

  return result
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// Human-readable labels for actions
export const auditLogActions = [
  { value: "HR_LOGIN", label: "HR Login" },
  { value: "HR_LOGIN_STEP_UP_COMPLETED", label: "HR Login (MFA Completed)" },
  { value: "ACCOUNTANT_LOGIN", label: "Accountant Login" },
  { value: "ACCOUNTANT_LOGIN_STEP_UP_COMPLETED", label: "Accountant Login (MFA Completed)" },
  { value: "ADMIN_LOGIN", label: "Admin Login" },
  { value: "ADMIN_LOGIN_STEP_UP_COMPLETED", label: "Admin Login (MFA Completed)" },
  { value: "COMPANY_ADMIN_LOGIN", label: "Company Admin Login" },
  { value: "COMPANY_ADMIN_LOGIN_STEP_UP_COMPLETED", label: "Company Admin Login (MFA Completed)" },
  { value: "EMPLOYEE_LOGIN", label: "Employee Login" },
  { value: "EMPLOYEE_LOGIN_STEP_UP_COMPLETED", label: "Employee Login (MFA Completed)" },
  {
    value: "HR_PASSWORD_RESET_REQUESTED",
    label: "HR Password Reset Requested",
  },
  {
    value: "HR_PASSWORD_RESET_COMPLETED",
    label: "HR Password Reset Completed",
  },
  { value: "HR_PROFILE_UPDATED", label: "HR Profile Updated" },
  { value: "HR_PASSWORD_CHANGED", label: "HR Password Changed" },
  { value: "NOTIFICATION_CREATED", label: "Notification Created" },
  { value: "EMPLOYEE_WAGE_UPDATED", label: "Employee Wage Updated" },
  { value: "EMPLOYEE_DISCHARGED", label: "Employee Discharged" },
  { value: "EMPLOYEE_STATUS_TOGGLED", label: "Employee Status Toggled" },
  { value: "EMPLOYEE_UPDATED", label: "Employee Updated" },
  { value: "ACCOUNTANT_ADDED", label: "Accountant Added" },
  { value: "ACCOUNTANT_STATUS_CHANGED", label: "Accountant Status Changed" },
  { value: "ACCOUNTANT_UPDATED", label: "Accountant Updated" },
  {
    value: "SUBSCRIPTION_EMPLOYEES_UPDATED",
    label: "Subscription Employees Updated",
  },
  { value: "AI_INTERVIEW_STARTED", label: "AI Interview Started" },
  { value: "INTERVIEW_SCHEDULED", label: "Interview Scheduled" },
  { value: "ZOOM_INTERVIEW_RESET", label: "Zoom Interview Reset" },
  { value: "INTERVIEW_RESET", label: "Interview Reset" },
    { value: "PAYROLL_GENERATED", label: "Payroll Generated" },
  { value: "PAYROLL_PAYOUT_TRIGGERED", label: "Payroll Payout Triggered" },
  { value: "PAYROLL_PROCESSED", label: "Payroll Processed" },
  { value: "PAYROLL_UPDATED", label: "Payroll Updated" },
  { value: "PAYROLL_DELETED", label: "Payroll Deleted" },
  { value: "PAYROLL_SYNCED_FROM_EVEREE", label: "Payroll Synced From Everee" },
  { value: "EMPLOYEE_SYNCED_TO_EVEREE", label: "Employee Synced To Everee" },
  { value: "EMPLOYEE_EVEREE_FIELDS_UPDATED", label: "Employee Everee Details Updated" },
  { value: "EMPLOYEE_DEACTIVATED_IN_EVEREE", label: "Employee Deactivated In Everee" },
  { value: "TIMESHEETS_SYNCED_TO_EVEREE", label: "Timesheets Synced To Everee" },
  { value: "EMPLOYEE_EXTERNAL_IDS_RECONCILED", label: "Everee IDs Reconciled" },
  { value: "EMPLOYEE_SYNC_AUDITED", label: "Everee Sync Audited" },

  { value: "PIPEDRIVE_CALLBACK", label: "Pipedrive Callback" },
  { value: "PIPEDRIVE_CONNECT_INITIATED", label: "Pipedrive Connect Initiated" },
  { value: "PIPEDRIVE_DISCONNECTED", label: "Pipedrive Disconnected" },
  { value: "PIPEDRIVE_API_TOKEN_CONNECTED", label: "Pipedrive Api Token Connected" },
];

// Human-readable results
export const auditLogResults = [
  { value: "SUCCESS", label: "Success" },
  { value: "DENIED", label: "Denied" },
  { value: "FAILURE", label: "Failure" },
];

// Human-readable roles
export const auditLogRoles = [
  { value: "admin", label: "Admin" },
  { value: "subadmin", label: "Sub Admin" },
  { value: "companyAdmin", label: "Company Admin" },
  { value: "HRAdmin", label: "HR Admin" },
  { value: "AccountantAdmin", label: "Accountant Admin" },
  { value: "employee", label: "Employee" },
  { value: "jobSeeker", label: "Job Seeker" },
];

export const formatIp = (ip) => {
  if (!ip) return null;
  // Remove ::ffff: prefix if present
  return ip.replace(/^::ffff:/, "");
};

export const formatResourceType = (type) => {
  if (!type) return null;
  return type
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/^./, (str) => str.toUpperCase());
};
